import React from "react";
import { Link } from "react-router-dom";
import PDFIcon from "../Images/pdfIcon.png";

const PaperAds = () => {
  const certificates = [
    {
      link: "Sukhabar Essex",
      title: "Sukhabar-Essex.pdf",
    },
    {
      link: "BS English Mumbai 11.04.2025",
      title: "BS-English-Mumbai-11.04.2025.pdf",
    },
    {
      link: "BS Hindi Delhi",
      title: "BS-Hindi-Delhi.pdf",
    },
    {
      link: "BS Hindi Mumbai 11.04.2025",
      title: "BS-Hindi-Mumbai-11.04.2025.pdf",
    },
  ];

  const downloadFile = (event, status) => {
    event.preventDefault();

    if (status) {
      const formattedUrl = `https://essexmpl.com/Pdf/${status}`;
      window.open(formattedUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          {certificates.map((certificate, id) => (
            <div className="col-md-6 col-lg-4" key={id}>
              <div className="team-item">
                <Link
                  to={"#"}
                  onClick={(e) => downloadFile(e, certificate.title)}
                  target="_blank"
                >
                  <img src={PDFIcon} alt="thumb" />
                  <div className="team-content">
                    <div className="team-bio">
                      <h5>
                        <a href="team.html">{certificate.title}</a>
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaperAds;
